var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWithdraw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16_1417",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16_1417)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60001 20.4C3.60001 19.7372 4.13726 19.2 4.80001 19.2H19.2C19.8628 19.2 20.4 19.7372 20.4 20.4C20.4 21.0628 19.8628 21.6 19.2 21.6H4.80001C4.13726 21.6 3.60001 21.0628 3.60001 20.4ZM7.55148 8.04854C7.08285 7.57991 7.08285 6.82008 7.55148 6.35145L11.1515 2.75148C11.3765 2.52644 11.6817 2.39999 12 2.39999C12.3183 2.39999 12.6235 2.52644 12.8485 2.75148L16.4485 6.35145C16.9171 6.82008 16.9171 7.57991 16.4485 8.04854C15.9799 8.51717 15.2201 8.51717 14.7515 8.04854L13.2 6.49705V15.6C13.2 16.2628 12.6627 16.8 12 16.8C11.3373 16.8 10.8 16.2628 10.8 15.6V6.49705L9.24853 8.04854C8.7799 8.51717 8.02011 8.51717 7.55148 8.04854Z",
    fill: "#FFB829"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWithdraw);
export default __webpack_public_path__ + "static/media/icon_withdraw.7616ebb7c16dafdcbfbb46f5a7adc347.svg";
export { ForwardRef as ReactComponent };